<template>
  <div>
    <md-list class="m-12-0">
      <md-list-item>
        <md-field
          v-model="computedValidityDesc"
          label="链接有效期"
          width="120"
          placeholder="7天"
          type="choose"
          @click="setValidityDate"
        ></md-field>
      </md-list-item>
    </md-list>
    <img
      class="m-0-16 w-342 mb-80"
      src="@/assets/images/wshare.png"
      alt="绑定指引"
    />
    <div class="footer fb fb-main-center fb-cross-center">
      <md-button @click="getShortLink">分享到微信</md-button>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { mcShare, mcToast, mcSetTitle } from '@/utils/mcSdkUtils'
export default {
  name: 'PageWechatGuideShare',
  data() {
    return {
      validityDate: 7,
      validityDateList: [],
      shortLink: '',
      classId: this.$route.query.classId
    }
  },
  computed: {
    computedValidityDesc() {
      return this.validityDate + '天'
    }
  },
  created() {
    mcSetTitle('家长信息管理')
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.initValidityDates()
    },
    // 获取短链
    getShortLink() {
      API.getShortLink({
        classId: this.classId,
        effectiveDay: this.validityDate
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            mcToast({
              msg: res.message || '获取短链失败'
            })
          } else {
            this.shortLink = res
            this.share()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 有效期下拉数据
    initValidityDates() {
      for (let i = 1; i < 31; i++) {
        this.validityDateList.push({
          name: `${i}天`,
          value: i
        })
      }
    },
    /**
     * 设置有效期
     */
    setValidityDate() {
      const _that = this
      this.$Picker({
        $props: {
          columns: this.validityDateList,
          defaultActive: this.validityDate - 1
        },
        $events: {
          confirm(index, data) {
            const { value } = data[0] || {}
            _that.validityDate = value
          }
        }
      }).show()
    },
    // 分享
    share() {
      mcShare({
        type: '0', // 分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
        url: `http://${this.shortLink}`,
        title: '家长信息',
        content: '家长信息',
        image: ''
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
